import { createSelector } from "@reduxjs/toolkit";
import { SOCIAL_NETWORK_FEATURE_KEY, AUTHENTICATION_FEATURE_KEY } from "./shared-authentication-feature-keys.js";
const EMPTY_STATE = {};
const getAuthenticationState = (rootState) => rootState[AUTHENTICATION_FEATURE_KEY] || EMPTY_STATE;
const getSocialNetworkState = (rootState) => rootState[SOCIAL_NETWORK_FEATURE_KEY] || EMPTY_STATE;
const selectSocialLoginStarted = createSelector(
  getSocialNetworkState,
  (s) => s.socialLoginStarted
);
const selectSocialRegistrationStarted = createSelector(
  getSocialNetworkState,
  (s) => s.socialRegistrationStarted
);
const selectCustomerConfirmationToken = createSelector(
  getAuthenticationState,
  (s) => s.confirmationToken
);
export {
  getAuthenticationState,
  getSocialNetworkState,
  selectCustomerConfirmationToken,
  selectSocialLoginStarted,
  selectSocialRegistrationStarted
};
